import { Profile } from "../profile";
import skrrrt from "./images/mockups/leah-skrrrt.png";
import skrrrt_white from "./images/mockups/leah-skrrrt-white.png";
import skrrrt_1 from "./images/studio/leah-skrrrt-1.png";
import skrrrt_2 from "./images/studio/leah-skrrrt-2.png";
import skrrrt_3 from "./images/studio/leah-skrrrt-3.png";
import smiley from "./images/mockups/leah-smiley.png";
import smiley_white from "./images/mockups/leah-smiley-white.png";
import smiley_1 from "./images/studio/leah-smiley-1.png";
import smiley_2 from "./images/studio/leah-smiley-2.png";
import smiley_3 from "./images/studio/leah-smiley-3.png";
import pint from "./images/mockups/leah-pint.png";
import pint_white from "./images/mockups/leah-pint-white.png";
import pint_1 from "./images/studio/leah-pint-1.png";
import pint_2 from "./images/studio/leah-pint-2.png";
import pint_3 from "./images/studio/leah-pint-3.png";
import fishi from "./images/mockups/leah-fishi.png";
import fishi_white from "./images/mockups/leah-fishi-white.png";
import fishi_1 from "./images/studio/leah-fishi-1.png";
import fishi_3 from "./images/studio/leah-fishi-3.png";

// Create the person first
const artist = new Profile("leah");
artist.insta = "leah_allen";
artist.description = "Leah is a multimedia artist who builds her work from the fragments of places she’s been. Using scans and photographs, she layers moments and textures to bring her visions to life. Her process is rooted in exploration - turning personal experiences and everyday materials into immersive visual worlds.";
artist.descriptionExtended = "TEST";

const details = `Digital print on 300gsm recycled paper. 
    Open edition (Unframed).
    Free UK postage only (Standard 5-10 working days).`;

artist.createSection("street stories. ");

artist.createItem("Skrrrt");
artist.setMockup(skrrrt);
artist.addImage(skrrrt_white);
artist.addImage(skrrrt_1);
artist.addImage(skrrrt_2);
artist.addImage(skrrrt_3);
artist.addDescription("Scanned in Taghazout, Morocco.");
artist.addDetails(details);
artist.addSizeAndPrice("A3 (29.7x42cm)", 30, "price_1SSbiJ2LxEhI4RHCU2EBqjS7");
artist.setId("leah-skrrrt");
artist.addTestPriceId("price_1SLnCa2LxEhI4RHCZ4iOX3m0");
artist.addDescription(`"A digital collage combining scanned textures from Taghazout with one of my photographs taken at the local skate park."`);

artist.createItem(":)");
artist.setMockup(smiley);
artist.addImage(smiley_white);
artist.addImage(smiley_1);
artist.addImage(smiley_2);
artist.addImage(smiley_3);
artist.addDescription("Scanned in Taghazout, Morocco.");
artist.addDetails(details);
artist.addSizeAndPrice("A3 (29.7x42cm)", 30, "price_1SSbix2LxEhI4RHCRhHjLMs3");
artist.setId("leah-:)");
artist.addTestPriceId("price_1SLnBr2LxEhI4RHCK3fikkmd");
artist.addDescription(`"A digital collage made from wall textures, paint scrapes, and graffiti I collected in Taghazout using my handheld scanner."`);

artist.createItem("Pint");
artist.setMockup(pint);
artist.addImage(pint_white);
artist.addImage(pint_1);
artist.addImage(pint_2);
artist.addImage(pint_3);
artist.addDescription("Scanned in Taghazout, Morocco.");
artist.addDetails(details);
artist.addSizeAndPrice("A3 (29.7x42cm)", 30, "price_1SSbjp2LxEhI4RHCAuoT5gXI");
artist.setId("leah-pint");
artist.addTestPriceId("price_1SLn6J2LxEhI4RHCZFS2wZoE");
artist.addDescription(`"Built from scanned wall textures and paint markings I gathered around Taghazout, combined into a digital collage."`);

artist.createItem("Fishi");
artist.setMockup(fishi);
artist.addImage(fishi_white);
artist.addImage(fishi_1);
artist.addImage(fishi_3);
artist.addDescription("Scanned in Taghazout, Morocco.");
artist.addDetails(details);
artist.addSizeAndPrice("A3 (29.7x42cm)", 30, "price_1SSbid2LxEhI4RHCP9tigVp1");
artist.setId("leah-fishi");
artist.addTestPriceId("price_1SLnCC2LxEhI4RHCf6C7w5c0");
artist.addDescription(`"A monochrome digital collage I created using scanned street textures and found markings from Taghazout."`);


export default artist;
